import { useShopContext } from '@zola/zola-ui/src/contexts/ShopContext/ShopContext';

import cx from 'classnames';

import bannerData, { weddingShopBannerData } from './bannerData';

import './Banner.less';

const Banner = ({
  isWeddingBoutiquePage,
}: {
  isWeddingBoutiquePage: string | undefined | null;
}) => {
  const { isBaby } = useShopContext();
  if (isBaby) {
    return null;
  }

  // to keep the default banner from rendering we will check for null here to verify that
  // the isWeddingBoutique data has not propagated yet
  if (isWeddingBoutiquePage === null) return null;
  let bannerItems = bannerData;
  if (isWeddingBoutiquePage) {
    bannerItems = weddingShopBannerData;
  }
  const banner = bannerItems.map((data) => (
    <a
      href={data.link}
      className={`shop-banner__link ${isWeddingBoutiquePage && 'wedding-shop'}`}
      key={data.title}
    >
      <div className={`zolaicon ${data.icon}`} />
      <div className="shop-banner__label">{data.title}</div>
      <div>
        <small className="details-link">details</small>
      </div>
    </a>
  ));
  return <div className={cx('shop-banner', 'shop-banner--navRedesign')}>{banner}</div>;
};

export default Banner;
